// @ts-nocheck 
// @ts-nocheck
// @ts-nocheck
import { Instance } from 'mobx-state-tree';
import { ProductModelBase } from './ProductModel.base';
import { ProductCategory } from './ProductCategoryEnum';
import { ProductSubCategory } from './ProductSubCategoryEnum';
import { getDiscountedValue } from '@/utils/helpers';
import _ from 'lodash';

/* The TypeScript type of an instance of ProductModel */
export interface ProductModelType extends Instance<typeof ProductModel.Type> {}

/* A graphql query fragment builders for ProductModel */
export {
  selectFromProduct,
  productModelPrimitives,
  ProductModelSelector,
} from './ProductModel.base';

const MIN_DISCOUNT_PRICE = 9.95;

/**
 * ProductModel
 *
 * Product
 */
export const ProductModel = ProductModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self));
  },
})).views((self) => ({
  get image(): string {
    return self.cms.tileImage?.url ?? '';
  },
  get isDiscountable(): boolean {
    if (!_.isNil(self.isBulkDiscountable)) return self.isBulkDiscountable;
    return (
      !self.hasSubProducts &&
      self.netPrice > MIN_DISCOUNT_PRICE &&
      (self.category === ProductCategory.MEALS ||
        self.category === ProductCategory.SALADS)
    );
  },
  get productDiscount(): number {
    return self.promotionTotal && self.grossPrice
      ? Math.trunc((self.promotionTotal / self.grossPrice) * 100)
      : 0;
  },
  get isWlpItem(): boolean {
    return (
      self.displaySubCategory &&
      self.displaySubCategory.includes(ProductSubCategory.WLP_BUNDLES)
    );
  },
  get packs(): number {
    return self.hasSubProducts && self.subProducts
      ? _.sumBy(self.subProducts, (sub) => sub.qty)
      : 0;
  },
  getDiscountedPrice(discount?: number): number {
    return this.isDiscountable && !!discount
      ? getDiscountedValue(self.netPrice, discount, true)
      : self.netPrice;
  },
  getWLPDiscountedPrice(discount?: number): number {
    return !!discount
      ? getDiscountedValue(self.netPrice, discount, true)
      : self.netPrice;
  },
}));
